import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import "regenerator-runtime/runtime";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.object.assign";
var defaultOptions = {
  // null for window, otherwise give css selector.
  // el to be observed should be a child of element given by this selector
  viewport: null,
  // accepts px and %
  modTop: '0px',
  modRight: '0px',
  modBottom: '0px',
  modLeft: '0px',
  // percentage of el that should intersect with viewport to consinder
  // it "in viewport". 0 means on the 1st pixel intersection or exit,
  // the respective handler will be called
  threshold: [0]
};
/**
 * Given a set of options, DOM node and in and out of viewport handlers,
 * this function uses an IntersectionObserver to figure out whether
 * the DOM node is in viewport or not and calls the respective handler.
 * It is a curried function and expects the parameters in the not so
 * common order so as to make it easier to observe multiple DOM nodes
 * with the same settings/options and maybe even the same handlers.
 *
 * @param {Node} target - target element to observe
 * and intersection threshold
 * @param {function} inHandler - fn to call when element is in viewport
 * for each given threshhold
 * @param {function} outHandler - fn to call when element leaves viewport
 * @param {object} opts - options to configure the viewport
 *
 * @return {function} unobserve element function
 */

export function observeElementInViewport(target, inHandler) {
  var outHandler = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
    return undefined;
  };
  var opts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  if (!target) {
    throw new Error('Target element to observe should be a valid DOM Node');
  }

  var _Object$assign = Object.assign({}, defaultOptions, opts),
      viewport = _Object$assign.viewport,
      modTop = _Object$assign.modTop,
      modLeft = _Object$assign.modLeft,
      modBottom = _Object$assign.modBottom,
      modRight = _Object$assign.modRight,
      threshold = _Object$assign.threshold;

  if (!Array.isArray(threshold) && !(typeof threshold === 'number')) {
    throw new Error('threshold should be a number or an array of numbers');
  } // The mod 101 is to prevent threshold from being greater than 1


  var thresholdArray = Array.isArray(threshold) ? threshold.map(function (t) {
    return Math.floor(t % 101) / 100;
  }) : [Math.floor(threshold ? threshold % 101 : 0) / 100];
  var minThreshold = Math.min.apply(Math, _toConsumableArray(thresholdArray));
  var intersectionObserverOptions = {
    root: viewport instanceof Node ? viewport : null,
    rootMargin: "".concat(modTop, " ").concat(modRight, " ").concat(modBottom, " ").concat(modLeft),
    threshold: thresholdArray
  };
  var isDebugEnabled = localStorage.debug && localStorage.debug.includes('observeElementInViewport');

  if (isDebugEnabled) {
    /* tslint:disable:no-console */
    console.log('IntersectionObserver options', intersectionObserverOptions);
    /* tslint:enable:no-console */
  }

  var cb = function cb(entries, observer) {
    var entryForEl = entries.filter(function (entry) {
      return entry.target === target;
    })[0];

    var unobserve = function unobserve() {
      return observer.unobserve(target);
    };

    if (entryForEl) {
      var isIntersecting = entryForEl.isIntersecting,
          intersectionRatio = entryForEl.intersectionRatio;
      entryForEl.isInViewport = isIntersecting && intersectionRatio >= minThreshold;

      if (entryForEl.isInViewport) {
        inHandler(entryForEl, unobserve, target);
      } else {
        outHandler(entryForEl, unobserve, target);
      }
    }
  };

  var intersectionObserver = new IntersectionObserver(cb, intersectionObserverOptions);
  intersectionObserver.observe(target);
  return function () {
    return intersectionObserver.unobserve(target);
  };
} // The function can return Promise that resolves to boolean or an object since in JS
// anything can be thrown thus we cannot not know what we reject with in the catch block

export var isInViewport = function isInViewport(el) {
  var opts,
      _args = arguments;
  return _regeneratorRuntime.async(function isInViewport$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          opts = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
          return _context.abrupt("return", new Promise(function (resolve, reject) {
            try {
              observeElementInViewport(el, function (_, unobserve) {
                unobserve();
                resolve(true);
              }, function (_, unobserve) {
                unobserve();
                resolve(false);
              }, opts);
            } catch (e) {
              reject(e);
            }
          }));

        case 2:
        case "end":
          return _context.stop();
      }
    }
  });
};